import { Controller } from "@hotwired/stimulus";

// Manages the Documents card state:
//   "cta"      → initial prompts (no uploads yet)
//   "upload"   → dropzone file upload area
//   "received" → file list with pending uploads
export default class extends Controller {
  static targets = ["ctaState", "uploadState", "receivedState", "fileList"];
  static values = { hasExistingUploads: { type: Boolean, default: false } };

  connect() {
    if (this.hasExistingUploadsValue) {
      this.showState("received");
    } else {
      this.showState("cta");
    }
  }

  showUpload() {
    this.showState("upload");
  }

  showBack() {
    if (this.hasExistingUploadsValue) {
      this.showState("received");
    } else {
      this.showState("cta");
    }
  }

  handleUploaded(event) {
    const { name, size } = event?.detail || {};
    if (name && this.hasFileListTarget) {
      this.appendFile(name, size);
    }
    this.hasExistingUploadsValue = true;
    this.showState("received");
  }

  appendFile(name, size) {
    const li = document.createElement("li");
    li.className = "list-group-item px-0 py-2 d-flex align-items-center";

    const sizeMb = size ? `${size} MB` : "";
    const today = new Date();
    const date = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;

    li.innerHTML = `
      <i class="fas fa-file-pdf text-danger me-2"></i>
      <div class="flex-grow-1 min-w-0">
        <div class="text-truncate small fw-medium">${this.escapeHtml(name)}</div>
        <span class="text-muted" style="font-size: 0.7rem;">${sizeMb} &middot; ${date}</span>
      </div>
    `;
    this.fileListTarget.prepend(li);
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  showState(state) {
    const states = ["cta", "upload", "received"];
    states.forEach((s) => {
      const hasTarget = this[`has${s.charAt(0).toUpperCase() + s.slice(1)}StateTarget`];
      if (hasTarget) {
        this[`${s}StateTarget`].classList.toggle("d-none", s !== state);
      }
    });
  }
}
